import React, { useCallback, useEffect, useState } from "react";
import { Link, redirect, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import BookingDetailItem from "../booking/BookingDetailItem";
import BookingDetailItemIcon from "../booking/BookingDetailItemIcon";
import { resetCruiseLineView, viewCruiseLine } from "src/store/reducers/cruiseLines";
import CruiseLineFormCanvas from "./CruiseLineFormCanvas";

const ViewCruiseLine = () => {
  const dispatch = useAppDispatch();

  const { id: cruiseLineId } = useParams();

  const cruiseLineViewStatus = useAppSelector((state) => state.cruiseLines.view.status);
  const cruiseLineData = useAppSelector((state) => state.cruiseLines.view.data);
  const [editId, setEditId] = useState("");

  useEffect(() => {
    if (!cruiseLineId) {
      redirect("/cruise-lines");
    }
  }, [cruiseLineId]);

  const retry = useCallback(() => {
    dispatch(viewCruiseLine(cruiseLineId));
  }, [cruiseLineId, dispatch]);

  useEffect(() => {
    if (cruiseLineViewStatus === "idle") {
      retry();
    }
  }, [cruiseLineViewStatus, retry]);

  useEffect(() => {
    if (cruiseLineData?.id !== cruiseLineId) {
      dispatch(resetCruiseLineView());
    }
  }, [cruiseLineData?.id, cruiseLineId, dispatch]);

  return (
    <>
      <div className="container-fluid mh-auto">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                {cruiseLineViewStatus === "success" && cruiseLineData ? (
                  <div className="row">
                    <div className="col-xl-3 col-lg-3  col-md-3 col-sm-3">
                      <div className="about-me">
                        <ul>
                          <BookingDetailItemIcon
                            title={"Cruise line name"}
                            icon={"ship"}
                            value={cruiseLineData.cruise_line_name}
                          />
                          <BookingDetailItemIcon
                            icon={"phone"}
                            title={"Contact number"}
                            value={cruiseLineData.contact_number}
                          />
                          <BookingDetailItemIcon
                            icon={"tag"}
                            title={"Cruise line code"}
                            value={cruiseLineData.cruise_line_code}
                          />
                          <BookingDetailItemIcon
                            icon={"user-md"}
                            title={"Contact person"}
                            value={cruiseLineData.contact_person_name}
                          />
                        </ul>
                      </div>
                      <div className="d-flex mt-4 justify-content-end">
                        <Link
                          to={"#"}
                          onClick={() => setEditId(cruiseLineData.id)}
                          className="modal-btn btn btn-primary btn-sm  ms-2"
                        >
                          <i className="fa-solid fa-pen-to-square me-1"></i>
                          Edit
                        </Link>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-9  col-md-9 col-sm-9">
                      <div className="product-detail-content">
                        <div className=" pr">
                          <div className="row">
                            <div className="col-xl-6 col-lg-6  col-md-6 col-sm-6 c-details">
                              <ul>
                                <BookingDetailItem
                                  title={"Email"}
                                  value={cruiseLineData.email_id}
                                />
                                <BookingDetailItem
                                  title={"Created"}
                                  value={new Date(
                                    cruiseLineData.created_date
                                  ).toLocaleString('en-IN')}
                                />
                                <BookingDetailItem
                                  title={"Updated"}
                                  value={new Date(
                                    cruiseLineData.updated_date
                                  ).toLocaleString('en-IN')}
                                />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : cruiseLineViewStatus === "pending" ||
                  cruiseLineViewStatus === "idle" ? (
                  <div className="d-flex align-items-center">
                    <strong>Loading...</strong>
                    <div
                      className="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                ) : cruiseLineViewStatus === "error" ? (
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={retry}
                    >
                      Retry
                    </button>{" "}
                    &nbsp;
                    <strong onClick={retry}>Please try again </strong>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {cruiseLineData ? (
        <>
          <CruiseLineFormCanvas
            show={editId !== ""}
            hide={() => setEditId("")}
            editId={editId}
            Title={editId === "Add" ? "Add Cruise Line" : "Edit Cruise Line"}
            cruiseLineData={cruiseLineData}
          />
        </>
      ) : null}
    </>
  );
};

export default ViewCruiseLine;
